import { __decorate } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
import { Mutation } from 'vuex-class';
import { ORDER } from '@/helpers/constants/Store';
/**
 * Constant for Vuex Order Module Namespace
 * @author Peter John Alvarado <peterjohn@gorated.ph>
 * @since Version 0.0.16
 */
const namespace = { namespace: ORDER };
let OrderDetailsMixin = class OrderDetailsMixin extends Vue {
    constructor() {
        super(...arguments);
        this.selectedOrderUuid = null;
    }
    /**
     * On View Order Method
     * @author Peter John Alvarado <peterjohn@gorated.ph>
     * @since Version 0.1.16
     */
    onViewOrder(orderUuid) {
        this.selectedOrderUuid = orderUuid;
        this.showOrderDetails();
    }
};
__decorate([
    Mutation('showOrderDetails', namespace)
], OrderDetailsMixin.prototype, "showOrderDetails", void 0);
OrderDetailsMixin = __decorate([
    Component
], OrderDetailsMixin);
export default OrderDetailsMixin;
